import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() companyData: any;

  constructor() { }

  ngOnInit(): void { }

  getAddress(companyData: any): string {
    if (!companyData) return '';

    const addressParts = [
      companyData.UnitNo ? companyData.UnitNo + ', ' : '',
      companyData.FloorAndTower ? companyData.FloorAndTower + ', ' : '',
      companyData.BuildingOrSociety ? companyData.BuildingOrSociety + ', ' : '',
      companyData.LocalityName ? companyData.LocalityName + ', ' : '',
      companyData.CityName || ''
    ];

    return addressParts.join('').trim().replace(/,\s*$/, ''); // to remove the last comma if present
  }
}
